import React, { useState } from "react";
import "./allpages.css";
import Header from '../../../layouts/doctor/DoctorHeader';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import { TableList } from './TableList';
import useEncryption from "../../../services/useEncryption";
import { useSelector, useDispatch } from "react-redux";
import { removeSelectedIds, selectAuth, setLeadPageRefresh } from "../../../redux/slice/authSlice";
import path from "../../../path";
import { createAuditLogs } from "../../../api/providerApi/providerApi";
import useHeaders from "../../../helpers/useHeaders";

export const LeadList = () => {
  const [value, setValue] = useState('All Leads');
  // const [refresh, setRefresh] = useState(false);
  const [search, setSearch] = useState("");
  const [allLeads, setAllLeads] = useState([]);
  const { selctedId, id, refresh } = useSelector(selectAuth);
  const { encryptData, decryptData } = useEncryption();
  const headers = useHeaders();
  const dispatch = useDispatch();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // const handleRefresh = () => {
  //   dispatch(setLeadPageRefresh(!refresh));
  // };
  const handleRefresh = () => {
  dispatch(setLeadPageRefresh(!refresh));
  dispatch(removeSelectedIds());   // <-- clear selected rows
};

  const passAllLeadsToDownloadCSV = (leads) => {
    setAllLeads(leads);
  };


  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  // const generateFile = async() => {
  //   try {
  //     window.location.href = `${path}/v1/lead/csv-export?data=${encodeURIComponent(encryptData(selctedId))}`;
  //     let obj = {
  //       event : 'Doctor has downloaded CSV File for the Leads.'
  //     }
  //     await createAuditLogs({ data: encryptData(obj)}, headers);
  //   } catch (error) {
  //     console.error("Error fetching doctors:", error);
  //   }
  // }

  const generateFile = async () => {
    let finalIds = [];
    if (selctedId && selctedId.length > 0) {
      finalIds = [...selctedId];   // take all selected
    } else {
      finalIds = [...allLeads];             // fallback
    }

    try {
      window.location.href = `${path}/v1/lead/csv-export?data=${encodeURIComponent(encryptData(finalIds))}`;
      let obj = {
        event: 'Doctor has downloaded CSV File for the Leads.'
      }
      await createAuditLogs({ data: encryptData(obj) }, headers);
      await dispatch(removeSelectedIds());

    } catch (error) {
      console.error("Error fetching doctors:", error);
    }
  }


  return (
    <div>
      <Header pageTitle="Leads" />
      <div className="cardOuter">
        <div className="cardheads">
          <div className="cardTitle">List View</div>
          <button className="btn blackoutlineBtn" onClick={handleRefresh}>Refresh</button>
        </div>
        <div className="cardcontents">
          <TabContext className="tabsDesigns" value={value}>
            <Tabs className="butoontabdesigns" onChange={handleChange}>
              <Tab className={value === "All Leads" ? "actived" : ""} label="All Leads" value="All Leads" />
              <Tab className={value === "New Lead" ? "actived" : ""} label="New Lead" value="New Lead" />
              <Tab className={value === "Scheduled For Contact" ? "actived" : ""} label="Scheduled For Contact" value="Scheduled For Contact" />
              <Tab className={value === "Contact Attempted" ? "actived" : ""} label="Contact Attempted" value="Contact Attempted" />
              <Tab className={value === "Ready To Schedule" ? "actived" : ""} label="Ready To Schedule" value="Ready To Schedule" />
              <Tab className={value === "In Process" ? "actived" : ""} label="In Process" value="In Process" />
              <Tab className={value === "Scheduled" ? "actived" : ""} label="Scheduled" value="Scheduled" />
              <Tab className={value === "UnScheduled" ? "actived" : ""} label="Unscheduled" value="UnScheduled" />
              <Tab className={value === "Archived" ? "actived" : ""} label="Archived" value="Archived" />
              
            </Tabs>

            <TabPanel className="tabpanelControl" value={value}>
              <div className="topsearchs">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="searchBar">
                    <input
                      type="text"
                      autoComplete="off"
                      placeholder="Search"
                      value={search}
                      onChange={handleSearchChange}
                    />
                  </div>
                  <button className="btn blackoutlineBtn" onClick={generateFile}>Download CSV</button>
                </div>


                <TableList key={refresh} activeTab={value} refresh={refresh} search={search} leadRows={passAllLeadsToDownloadCSV}/>
              </div>
            </TabPanel>
          </TabContext>
        </div>
      </div>
    </div>
  );
};
